import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../context/AnalyticsContext';

/**
 * Sayfa ziyareti takibi için custom hook
 * Otomatik olarak sayfa değişikliklerini takip eder
 */
export const usePageTracking = () => {
  const location = useLocation();
  const { trackPageView, isInitialized } = useAnalytics();
  const startTimeRef = useRef(Date.now());
  const currentPathRef = useRef(location.pathname);

  // Sayfa değişikliğini takip et
  useEffect(() => {
    if (!isInitialized) return;

    const currentTime = Date.now();
    const timeSpent = Math.floor((currentTime - startTimeRef.current) / 1000);

    // Önceki sayfa için süre kaydet (ilk yükleme değilse)
    if (currentPathRef.current !== location.pathname) {
      trackPageView(
        currentPathRef.current,
        document.title,
        timeSpent,
        document.referrer
      );
    }

    // Yeni sayfa için başlangıç zamanını güncelle
    startTimeRef.current = currentTime;
    currentPathRef.current = location.pathname;

    // Yeni sayfa görüntüleme kaydet
    trackPageView(
      location.pathname,
      document.title,
      0, // Yeni sayfa için süre 0
      document.referrer
    );

  }, [location.pathname, trackPageView, isInitialized]);

  // Sayfa kapatılırken son süreyi kaydet
  useEffect(() => {
    const handleBeforeUnload = () => {
      const timeSpent = Math.floor((Date.now() - startTimeRef.current) / 1000);
      if (timeSpent > 0) {
        trackPageView(
          currentPathRef.current,
          document.title,
          timeSpent,
          document.referrer
        );
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [trackPageView]);

  // Sayfa görünürlük değişikliğini takip et (tab değişimi)
  useEffect(() => {
    let hiddenTime = null;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Sayfa gizlendi
        hiddenTime = Date.now();
      } else if (hiddenTime) {
        // Sayfa tekrar görünür oldu
        const timeHidden = Date.now() - hiddenTime;
        if (timeHidden > 30000) { // 30 saniyeden fazla gizli kaldıysa
          // Sayfa süresini güncelle
          startTimeRef.current = Date.now();
        }
        hiddenTime = null;
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  return {
    currentPath: location.pathname,
    startTime: startTimeRef.current
  };
};

export default usePageTracking;
